import isNil from 'lodash/isNil';
import { createSelector } from 'reselect';
import { LongTermCareInsuranceProgressAreaChart } from '../../../../../js/app/react/chartDescriptors.financialPlan';
import { selectedIndex as selectedOwnerIndex } from '../../OwnerDropdown/OwnerDropdownSelector';
import { computeChartIndex, computeChartStringKey } from './ProgressChartHelpers';

const BASE_LOCAL_DATA = {
    localChartData: null,
    localGroup: null,
    localGoalData: null,
    localResponseData: null,
  },
  GFX_PATH = ADV.settings.endpoints.imgDir + 'chart_sprites/',
  dictionary = {},
  seriesZIndex = (chartData, seriesIndex, otherSeriesIndex) => {
    let numberOfSeriesTopPoints = 0,
      totalPoints = 0,
      otherSeriesArray = chartData.series[otherSeriesIndex].data;
    chartData.series[seriesIndex].data.forEach(({ y }, index) => {
      if (y > 0 || otherSeriesArray[index].y > 0) {
        totalPoints++;
      }
      if (y > otherSeriesArray[index].y) {
        numberOfSeriesTopPoints++;
      }
    });
    if (totalPoints == 0) {
      return seriesIndex < otherSeriesIndex ? 1 : 2;
    }
    return numberOfSeriesTopPoints > totalPoints / 2 ? 1 : 2;
  };

export const responseDataSelector = (state, props) => {
    const ownerIndex = !isNil(props.ownerIndex)
        ? props.ownerIndex
        : selectedOwnerIndex(state, props),
      chartIndex = computeChartIndex(ownerIndex === 1);

    return {
      ...props,
      ownerIndex,
      chartIndex,
    };
  },
  goalDataSelector = (state, props) => {
    const responseData = responseDataSelector(state, props),
      data = responseData.subgoalData.GoalCharts[responseData.chartIndex];
    return {
      ownerIndex: responseData.ownerIndex,
      responseData: data,
    };
  },
  chartDataSelector = createSelector(
    [
      (state, props) => {
        const goalData = goalDataSelector(state, props);
        return {
          ...goalData,
          isPrint: props.isPrint,
          isCurrentPlan: props.isCurrentPlan,
          key: computeChartStringKey(
            goalData.ownerIndex.toString(),
            `${props.subgoalId}`,
            props.fpId,
            props.clientId,
          ),
        };
      },
    ],
    ({ responseData, isPrint, isCurrentPlan, key }) => {
      if (responseData == null || Object.keys(responseData).length < 1) {
        return null;
      }

      if (!dictionary[key]) {
        dictionary[key] = clone(BASE_LOCAL_DATA);
      }

      if (ADV.util.deepEqual(responseData, dictionary[key].localResponseData)) {
        return dictionary[key].localChartData;
      }
      const chartData = clone(LongTermCareInsuranceProgressAreaChart);

      if (isCurrentPlan) {
        chartData.title.text = '';
      }
      const numberOfCategories = responseData.Data.Categories.length;
      if (numberOfCategories) {
        let tick;
        chartData.xAxis.tickPositions = [];
        for (tick = 0; tick < numberOfCategories; tick += 5) {
          chartData.xAxis.tickPositions.push(tick);
        }
        if (tick !== numberOfCategories) {
          chartData.xAxis.tickPositions.push(numberOfCategories - 1);
        }
      }

      chartData.xAxis.categories = responseData.Data.Categories;
      if (
        responseData.IsEmpty ||
        (responseData.Data.Series.Recommended.filter(y => y).length == 0 &&
          responseData.Data.Series.Current.filter(y => y).length == 0)
      ) {
        chartData.yAxis.max = 10000;
      } else {
        chartData.yAxis.max = null;
      }

      chartData.series[0].data = responseData.Data.Series.Recommended;
      chartData.series[1].data = responseData.Data.Series.Current;

      chartData.series[0].zIndex = seriesZIndex(chartData, 0, 1);
      chartData.series[1].zIndex = seriesZIndex(chartData, 1, 0);

      if (isPrint) {
        chartData.series.forEach(serie => {
          serie.animation = false;
        });
      }

      dictionary[key].localResponseData = responseData;
      dictionary[key].localChartData = chartData;
      return chartData;
    },
  );
